import IntegrationsConnectButton from './IntegrationsConnectButton';
import { useTranslation } from 'react-i18next';
import JTLIcon from '@/icons/jtl.svg';

interface Props {
  hasCredentials?: boolean;
  onClickConnect: () => void;
}

export const JTLWidget = ({ hasCredentials, onClickConnect }: Props) => {
  const { t } = useTranslation();
  return (
    <>
      <div
        className='flex items-center justify-between font-bold'
        data-testid='integrations-jtl'
      >
        <div className='flex items-center'>
          <img
            src={JTLIcon}
            alt='jtl'
            style={{
              width: 40,
              height: 40,
            }}
            className='mr-2 flex-shrink-0'
          />
          <span>JTL</span>
        </div>
        <IntegrationsConnectButton
          testId={'jtl-btn'}
          onClick={onClickConnect}
        />
      </div>
      {hasCredentials && (
        <div className='mt-2'>
          <div className='flex items-center justify-between rounded-lg bg-green bg-opacity-[0.12] px-2 py-1'>
            <div>{t('Credentials were generated.')}</div>
          </div>
        </div>
      )}
    </>
  );
};
